import { Reveal } from "./Reveal";
import { ArrowRight } from "lucide-react";

const ITEMS = [
  "European employer connections",
  "Vacancy sourcing",
  "Candidate supply",
  "B2B recruitment cooperation",
  "Country-specific recruitment projects",
  "Structured communication",
  "Compliance & verification support",
];

export const Partners = () => (
  <section id="partners" data-testid="partners-section" className="py-24 md:py-32 px-6 md:px-12">
    <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-5">
        <p className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30] mb-6">
          For recruitment agencies / B2B partners
        </p>
        <h2 className="font-head uppercase tracking-tighter leading-[0.9] text-4xl md:text-6xl mb-8">
          Grow your recruitment business across Europe.
        </h2>
        <a
          href="#partner"
          data-testid="partners-cta"
          className="group inline-flex items-center gap-3 bg-[#0a0a0a] hover:bg-[#ff3b30] text-white font-head uppercase text-sm tracking-wide px-8 py-4 w-max transition-colors duration-300"
        >
          Become a recruitment partner
          <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
        </a>
      </Reveal>

      <Reveal delay={0.15} className="lg:col-span-7 lg:pl-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10">
          {ITEMS.map((it, i) => (
            <div
              key={it}
              data-testid={`partner-item-${i}`}
              className="flex items-baseline gap-4 py-5 border-b border-[#e4e4e7]"
            >
              <span className="font-head text-lg text-[#ff3b30]">0{i + 1}</span>
              <span className="font-body text-[#0a0a0a]">{it}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
